export default {
  props: {
    namespace: {
      type: String,
      required: false,
      default: 'common',
    },
    field: {
      type: Object,
      required: true,
    },
    isValid: {
      type: Boolean,
      required: false,
      default: false,
    },
    isTainted: {
      type: Boolean,
      required: false,
      default: false,
    },
    errorMessages: {
      type: Array,
      required: false,
      default: undefined,
    },
    initialValue: {
      type: String || Number || Boolean,
      required: false,
      default: undefined,
    },
    isVisible: {
      type: Boolean,
      required: false,
      default: true,
    },
    isVisibleRequired: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    values() {
      return this.$store.state[this.namespace].values
    },
    thisValue: {
      get() {
        return this.values[this.field.name]
      },
      set(value) {
        this.onChangeValue({ name: this.field.name, value })
      },
    },
    hasValue() {
      return this.thisValue && this.thisValue !== ''
    },
    requiredText() {
      if (this.isVisibleRequired) {
        const rules = this.field.rules
        const typeOfRules = Object.prototype.toString.call(rules)
        return rules === 'required' || (typeOfRules === '[object Object]' && rules.required)
          ? '（必須）'
          : '（任意）'
      } else {
        return ''
      }
    },
  },
  methods: {
    onChangeValue(payload) {
      this.$store.dispatch(`${this.namespace}/onChangeValue`, payload)
    },
  },
}
